import { normalizeNamespaceAndPath } from '~/helpers';
import { useModelsStore, useSettingsStore } from '~/stores';

export function featuresStateLoaded(feature: string | string[]): boolean {
    if (Array.isArray(feature)) {
        const results = feature.map((feature) => featuresStateLoaded(feature));
        return results.every((elem) => elem);
    }

    const normalized = normalizeNamespaceAndPath(feature);
    const namespace = normalized.split(':').shift();

    const modelsStore = useModelsStore();
    const settingsStore = useSettingsStore();

    switch (namespace) {
        case 'server':
            return !!modelsStore.server;
        case 'admin':
        case 'general':
            return !!settingsStore.data;
    }

    return false;
}

// NOTE: The initial page load will not have the required data for this due to how we prefer skeleton loading
// for page contents. Instead, using `computed` should be enough to make the feature state refresh after it is loaded.
export function hasFeatures(feature: string | string[], matchAny = false): boolean {
    if (Array.isArray(feature)) {
        const results = feature.map((feature) => hasFeatures(feature));
        return results[matchAny ? 'some' : 'every']((elem) => elem);
    }

    const normalized = normalizeNamespaceAndPath(feature);
    const namespace = normalized.split(':').shift();

    const modelsStore = useModelsStore();
    const settingsStore = useSettingsStore();

    switch (namespace) {
        case 'server':
            return modelsStore.server?.features.isAvailable(normalized) || false;
        case 'admin':
        case 'general':
            return settingsStore.data?.features[normalized]?.available || false;
    }

    return false;
}
